const handleCloseMyCompany = {
  confirm: '¿Realmente desea salir sin guardar sus cambios?',
  title: 'CAMBIOS NO GUARDADOS'
};

export default handleCloseMyCompany;
